import './PrintMultiTenant.scss';
import Component from './PrintMultiTenant.js';
export default Component;
